





























import { Decoder } from '@simonbackx/simple-encoding';
import { isSimpleError, isSimpleErrors } from '@simonbackx/simple-errors';
import { InputBox } from "@goodless/components"
import { Address, Country } from "@goodless/structures"
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ErrorBox, Validator } from '@simonbackx/simple-error-forms';

@Component({
    components: {
        InputBox
    }
})
export default class AddressInput extends Vue {
    /**
     * Assign a validator if you want to offload the validation to components
     */
    @Prop({ default: null }) 
    validator: Validator | null

    errorBox: ErrorBox | null = null
    pendingErrorBox: ErrorBox | null = null
    
    @Prop({ default: null })
    value: Address | null

    @Prop({ default: true })
    required: boolean

    addressLine1 = ""
    city = ""
    postalCode = ""
    country = Country.Belgium

    hasFocus = false

    @Watch('value', { deep: true })
    onValueChanged(val: Address | null) {
        if (!val) {
            return
        }
        this.addressLine1 = val.street+" "+val.number
        this.city = val.city
        this.postalCode = val.postalCode
        this.country = val.country
    }

    onBlur() {
        this.hasFocus = false
    }

    onFocus() {
        this.hasFocus = true
    }

    mounted() {
        if (this.validator) {
            this.validator.addValidation(this, () => {
                return this.isValid()
            })
        }

        if (this.value) {
            this.addressLine1 = this.value.street+" "+this.value.number
            this.city = this.value.city
            this.postalCode = this.value.postalCode
            this.country = this.value.country
        }
    }

    destroyed() {
        if (this.validator) {
            this.validator.removeValidation(this)
        }
    }

    async isValid(): Promise<boolean> {
        if (!this.required && this.addressLine1.length == 0 && this.postalCode.length == 0 && this.city.length == 0) {
            this.errorBox = null

            if (this.value !== null) {
                this.$emit("input", null)
            }
            return true
        }

        let address: Address

        try {
            address = Address.createFromFields(this.addressLine1, this.postalCode, this.city, this.country)
            this.$emit("input", address)            
            this.errorBox = null
            this.pendingErrorBox = null
            return true
        } catch (e) {
            if (isSimpleError(e) || isSimpleErrors(e)) {
                this.pendingErrorBox = new ErrorBox(e)

                // We add a delay here in case the user simply selects a different field
                setTimeout( () => {
                    if (!this.hasFocus) {
                        this.errorBox = this.pendingErrorBox
                    }
                }, 100);
            }

            if (!this.required) {
                this.$emit("input", null)
            }
            return false
        }
    }

    updateAddress() {
       this.isValid()
    }
}
